import mime from "mime";

export const parseFileDataFromUrl = (url: string) => {
  const regex = new RegExp(/.+\/{2}.+\/{1}.+(\.\w+)\?*.*/);
  const isFile = regex.test(url);
  if (!isFile) {
    return null;
  }
  const directorySplit = url.split(/[#?]/)[0].split("/");
  const fileName = directorySplit[directorySplit.length - 1];
  const fileNameSplited = fileName.split(".");

  let ext;
  if (mime.getType(fileName) && fileNameSplited.length > 1) {
    ext = fileNameSplited.pop();
  }
  const name = fileNameSplited.join(".");
  return {
    ext,
    name,
  };
};
